import { Injectable } from '@angular/core';
import {SdkResponse} from 'onfido-sdk-ui';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataListModel} from '../../models/data-list-model';
import {CardCreationImport} from '../../dto/card-creation-import';
import {CorporateForm} from '../../dto/corporate-form';

@Injectable({
  providedIn: 'root'
})
export class OnfidoService {

  readonly apiPath = 'onfido/';
  readonly headers = new HttpHeaders({ 'No-Auth': 'True' });

  constructor(
    private http: HttpClient,
  ) { }


  getWebSdkTokenForOrderId(protectedOrderId: string) {

    const url = this.apiPath + 'start/' + protectedOrderId;

    return this.http.get(url, {headers: this.headers }) as Observable<string>;
  }

  doCheck(data: SdkResponse, protectedOrderId: string) {
    const url = this.apiPath + 'complete/' + protectedOrderId;
    return this.http.post(url, { params: {oh: 1} }, { headers: this.headers }) as Observable<string>;
  }
}
